(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bella-newsletter"] && !Shopify.designMode) return;
  try {
    (() => {
const dialog=document.querySelector('[data-ba-newsletter]');
if(!dialog)return;
let opener;
const key='ba-newsletter-dismissed-v2';
const subscribedKey='ba-newsletter-subscribed-v2';
const pendingKey='ba-newsletter-pending-v2';
const sessionRead=()=>{try{return Number(sessionStorage.getItem(pendingKey)||0)}catch{return 0}};
const sessionClear=()=>{try{sessionStorage.removeItem(pendingKey)}catch{}};
const pendingAt=sessionRead();
const pending=pendingAt>0&&Date.now()-pendingAt<10*60*1000;
const read=(k)=>{try{return localStorage.getItem(k)}catch{return null}};
const write=(k,v)=>{try{localStorage.setItem(k,v)}catch{}};
const blocked=()=>document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])');
const open=()=>{if(dialog.open)return;opener=document.activeElement;dialog.showModal()};
const close=()=>{dialog.close();write(key,String(Date.now()));if(opener instanceof HTMLElement)opener.focus()};
document.querySelectorAll('[data-ba-newsletter-open]').forEach(b=>b.addEventListener('click',open));
dialog.querySelectorAll('[data-ba-newsletter-close]').forEach(b=>b.addEventListener('click',close));
dialog.querySelector('form')?.addEventListener('submit',()=>{const form=dialog.querySelector('form');if(!form.checkValidity())return;try{sessionStorage.setItem(pendingKey,String(Date.now()))}catch{}dialog.close()});
dialog.addEventListener('cancel',()=>{write(key,String(Date.now()))});
dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close()}});
const success=dialog.querySelector('[data-ba-newsletter-success]');
const fields=dialog.querySelector('[data-ba-newsletter-fields]');
const errors=dialog.querySelector('[data-ba-newsletter-errors]');
if(success&&pending&&!errors){success.hidden=false;fields.hidden=true;sessionClear();write(subscribedKey,'yes');open();return}
if(success)success.remove();
if(!pending)sessionClear();
if(errors&&pending){sessionClear();open();return}
if(location.pathname.startsWith('/cart')||read(subscribedKey)||Date.now()-Number(read(key)||0)<30*24*60*60*1000)return;
let attempts=0;
const invite=()=>{if(document.visibilityState!=='visible'||blocked()||document.activeElement?.matches('input,textarea,select')||document.querySelector('#es-popup-background[style*="display: block"]')){if(++attempts<6)setTimeout(invite,5000);return}open()};
setTimeout(invite,10000);
})();
  } catch(e) { console.error(e); }
})();

})();
